import api from '@/services/api'

export const loadDiseasesFromAPI = async patientRecordId => {
  try {
    const [generalDiseasesResponse, patientDiseasesResponse] =
      await Promise.all([
        api.get('/diseases'),
        api.get(`/pacientes/${patientRecordId}`)
      ])

    const generalDiseases = generalDiseasesResponse.data.data
    const patientData = patientDiseasesResponse.data.data

    if (Array.isArray(generalDiseases) && Array.isArray(patientData.diseases)) {
      const patientDiseases = patientData.diseases.reduce((acc, disease) => {
        acc[disease.id] = {
          ...disease,
          description: disease.pivot.description || '',
          family_members: JSON.parse(disease.pivot.family_members) || [],
          active: disease.pivot.active === 1
        }
        return acc
      }, {})

      return generalDiseases.map(category => ({
        ...category,
        diseases: category.diseases.map(disease => {
          const patientDisease = patientDiseases[disease.id]
          return {
            ...disease,
            description: patientDisease
              ? patientDisease.description
              : disease.description || '',
            family_members: patientDisease
              ? patientDisease.family_members
              : disease.family_members || [],
            active: patientDisease
              ? patientDisease.active
              : disease.active !== undefined
                ? disease.active
                : true
          }
        })
      }))
    } else {
      console.error(
        'Formato inesperado de respuesta:',
        generalDiseases,
        patientData
      )
      return []
    }
  } catch (error) {
    console.error('Error al cargar enfermedades desde la API:', error)
    return []
  }
}

export const updateDisease = async (patientRecordId, updatedDisease) => {
  try {
    await api.put(`/pacientes/${patientRecordId}/diseases`, {
      diseases: [updatedDisease]
    })
    //console.log('Enfermedad actualizada:', response.data)
  } catch (error) {
    console.error('Error al actualizar la enfermedad del paciente:', error)
  }
}
